import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { HdPopconfirmComponent } from "./hd-popconfirm.component";

@NgModule({
  declarations: [
    HdPopconfirmComponent
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    NgZorroAntdModule,
  ],
  exports: [HdPopconfirmComponent],
  providers: [],
  bootstrap: [HdPopconfirmComponent]
})
export class HdPopconfirmModule {
}
